import { render, staticRenderFns } from "./CentralSection.vue?vue&type=template&id=976efb58&scoped=true&"
import script from "./CentralSection.vue?vue&type=script&lang=js&"
export * from "./CentralSection.vue?vue&type=script&lang=js&"
import style0 from "./CentralSection.vue?vue&type=style&index=0&id=976efb58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976efb58",
  null
  
)

export default component.exports